import { HttpResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
/**
 * Saves a file by opening file-save-as dialog in the browser
 * using file-save library.
 * @param blobContent file content as a Blob
 * @param fileName name file should be saved as
 */
export const saveFile = ( blobContent: Blob, fileName: string, opcion: string ) => {

    let tipo: string = 'application/pdf';
    if ( opcion == "imagen" ) {
        tipo = 'application/octet-stream';//'image/jpg';
    }

    let blob = new Blob( [blobContent], { type: tipo } );
    saveAs( blob, fileName );
};


export const base64ToFile = ( base64Data: any, name: string, type: string ) => {
    type = type || '';
    const sliceSize = 1024;
    const byteCharacters = atob( base64Data );
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil( bytesLength / sliceSize );
    const byteArrays = new Array( slicesCount );

    for ( let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex ) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min( begin + sliceSize, bytesLength );

        const bytes = new Array( end - begin );
        for ( let offset = begin, i = 0; offset < end; ++i, ++offset ) {
            bytes[i] = byteCharacters[offset].charCodeAt( 0 );
        }
        byteArrays[sliceIndex] = new Uint8Array( bytes );
    }
    return new File( byteArrays, name, { type: type } );

};
